// Module
var code = "<template> <require from=\"app/cd/components/summary/provider/provider-summary\" as=\"summary\"></require> <summary provider.bind=\"provider\" provider-location-id.bind=\"locationId\"></summary> </template> ";
// Exports
module.exports = code;